import { EVENT_OPTION_CONFIG } from 'components/Pages/Admin/Itinerary/Details/DetailsChronologicalMode/Event/config';

import { useShowNavigationModal } from '../..';
import { Events } from './Events';
import s from './index.module.css';
import { MoreDetailsButton } from './MoreDetailsButton';
import { useTravelBriefMoreDetails } from './MoreDetailsButton/functions';
import { IActivitiesCellProps } from './types';

/**
 * Renders the activities cell for a trip event.
 * This component is rendered only when the value of "activeType" is EEventType.All or EEventType.Flight.
 *
 * @param {object} tripEvent - The trip event object.
 * @param {array} data - The data array.
 * @param {string} activeType - The active type.
 * @param {boolean} readonly - Whether the component is readonly. Defaults to false.
 * @param {string} timeFormat - The time format.
 * @return {JSX.Element} The activities cell JSX element.
 */

export const ActivitiesCell = ({ tripEvent, data, activeType, readonly = false, timeFormat }: IActivitiesCellProps) => {
  const { detailsConfig } = useTravelBriefMoreDetails({ tripEvent });
  const details = detailsConfig(tripEvent.type);
  const allNull = details?.every((el) => el === null);
  const showNavigationModal = useShowNavigationModal();

  const { getContent, getLabel } = EVENT_OPTION_CONFIG[tripEvent.type];

  return (
    <div
      className={s.eventContainer}
      onClick={(event) => {
        showNavigationModal(tripEvent.id);
        event.stopPropagation();
      }}
    >
      <Events
        icon={tripEvent.icon}
        content={getContent(tripEvent, { readonly, timeFormat })}
        label={getLabel(tripEvent, { readonly, timeFormat })}
        activeType={activeType}
      />
      {!allNull && <MoreDetailsButton tripEvent={tripEvent} activeType={activeType} detailsConfig={detailsConfig} />}
      {data.length > 1 && <div className={s.divider} />}
    </div>
  );
};
